import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'

import NoResults from '@/components/util/NoResults'

import { Translation } from '../i18n/Translation'

import { PolicyListItem } from './PolicyListItem'
import type { PolicyCoreData } from './types'

const PolicyList: FC<{ policyList?: PolicyCoreData[]; isLoading: boolean }> = ({
  policyList,
  isLoading,
}) => {
  if (isLoading)
    return (
      <ul className="m-0 p-0">
        <LoaderCircle />
      </ul>
    )

  if (!policyList) return null

  if (policyList.length === 0) {
    return (
      <NoResults>
        <Translation id="Din arbeidsgiver har ikke åpnet for kjøp av utstyr" />
      </NoResults>
    )
  }

  return (
    <ul className="m-0 list-none p-0">
      {policyList.map(policy => (
        <PolicyListItem key={policy.id} {...policy} />
      ))}
    </ul>
  )
}

export default PolicyList
